import React, { useEffect, useState } from 'react';
import {
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { HCE_ESTADOS } from '../../../utils/constants';
import { Search } from '@material-ui/icons';
import {
  TraerTurnosMedicos,
  setEstadoTurnosHce,
} from '../../../actions/hce/hceActions';
import moment from 'moment';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { useForm } from '../../../hooks/useForm';
import { HceItem } from './HceItem';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { startAlerta } from '../../../actions/ui/alertas';


const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    // padding: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
});

const today = new Date();
const stateInitial = {
  fecha: today,
};

export const ListadoPacientes = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [nroDocumento, setNroDocumento] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [idConexion, setIdConecion] = useState("");
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [formValues, , , setearValor] = useForm(stateInitial);
  const { fecha } = formValues;
  const { idEfectorRed, idCentroMedico, piso, consultorio, relEfectorCMEspe } = props;

  const { estadoTurnos, items } = useSelector((state) => state.hce);
  const { dni } = useSelector((state) => state.auth);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const baseUrl = process.env.REACT_APP_URL;


  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(`${baseUrl}/hubs/logs/teleconsulta`)
      .withAutomaticReconnect()
      .build();
    //INICIAR CONEXION
    connection.start()
      .then(result => {
        console.log('Connected!');
        const id = connection.connection.connectionId;
        setIdConecion(id)
        //AVISO DE PACIENTE EN SALA
        connection.on('PacienteEnSala', (messages) => {
          dispatch(
            startAlerta(
              'Paciente en sala',
              'success',
              'Comando Exitoso',
            ),
          );
          dispatch(
            TraerTurnosMedicos(fecha, HCE_ESTADOS.CONFIRMADOS, idEfectorRed, idCentroMedico, id)
          );
        });
        //AVISO DE PACIENTE DESLOGUEADO
        connection.on('PacienteDeslogueado', () => {
          dispatch(
            TraerTurnosMedicos(fecha, HCE_ESTADOS.CONFIRMADOS, idEfectorRed, idCentroMedico, id)
          );
          dispatch(
            startAlerta(
              'Paciente deslogueado',
              'success',
              'Comando Exitoso',
            ),
          );
        });
      })
      .catch(e => console.log('Connection failed: ', e));
    return () => {
      connection.stop();
    };
  }, [baseUrl, dispatch]);

  useEffect(() => {
    const fetchData = () => {
      if (idConexion !== "") {
        dispatch(
          TraerTurnosMedicos(fecha, estadoTurnos, idEfectorRed, idCentroMedico, idConexion)
        );
      }
    };
  
    // Llama a fetchData() al principio para que se ejecute inmediatamente
    fetchData();
  
    // Establece el intervalo para ejecutar fetchData() cada minuto
    const intervalId = setInterval(fetchData, 60000);
  
    // Limpia el intervalo cuando el componente se desmonta o el id de la conexión cambia
    return () => clearInterval(intervalId);
  }, [dispatch, estadoTurnos, dni, fecha, idConexion]);

  const arrayEstadosTurnos = Object.entries(HCE_ESTADOS);

  const componentRef = React.useRef();

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={10}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                fullWidth
                type="number"
                label="Buscar Por DNI"
                name="nroDocumento"
                value={nroDocumento}
                autoComplete="off"
                onChange={(e) => setNroDocumento(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ marginTop: -25, marginRight: -10 }}
                    >
                      <IconButton
                        aria-label="Buscar"
                        onClick={() => {
                          //   dispatch(BuscarAfiliadoPorDNI(nroDocumento));
                          //   dispatch(
                          //     BuscadorBandejaPorAfiliado(
                          //       nroDocumento,
                          //       areasFisicasUsuario.idArea,
                          //       estadoSolicitudes
                          //     )
                          //   );
                        }}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha"
                  format="dd/MM/yyyy"
                  // required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fecha).isValid() ? moment(fecha) : null}
                  onChange={(date) => {
                    setearValor('fecha', date);
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: '0.25rem', marginTop: -5 }}>
          <RadioGroup
            row
            style={{ justifyContent: 'space-around' }}
            value={estadoTurnos}
            onChange={(e) => {
              dispatch(setEstadoTurnosHce(e.target.value));
            }}
          >
            {arrayEstadosTurnos.map((estadoTurnos, index) => {
              const label =
                estadoTurnos[0].charAt(0) +
                estadoTurnos[0].replace('_', ' ').toLowerCase().slice(1);
              return (
                <FormControlLabel
                  key={index}
                  style={{ marginLeft: '0.5rem' }}
                  label={label}
                  value={estadoTurnos[1]?.toString()}
                  control={<Radio />}
                />
              );
            })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
          <Table size={dense ? 'small' : 'medium'} ref={componentRef}>
            <TableHead>
              <TableRow>
                {/* <TableCell></TableCell> */}
                <TableCell align="left">Fecha</TableCell>
                <TableCell align="left">Hora</TableCell>
                <TableCell align="left">Día</TableCell>
                <TableCell align="left">Carnet</TableCell>
                <TableCell align="left">Apellido y Nombre</TableCell>
                <TableCell align="left">Sobreturno</TableCell>
                <TableCell align="left">Especialidad</TableCell>
                {parseInt(estadoTurnos) === HCE_ESTADOS.CONFIRMADOS && (
                  <TableCell align="left">Atendido</TableCell>
                )}
                {parseInt(estadoTurnos) === HCE_ESTADOS.CONFIRMADOS && (
                  <TableCell align="left">VideoConsulta</TableCell>
                )}
                {parseInt(estadoTurnos) === HCE_ESTADOS.CONFIRMADOS && (
                  <TableCell align="left">HCE</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 ? (
                items
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <HceItem
                      item={item}
                      key={item.id || index} // Utiliza item.id si está disponible, de lo contrario, utiliza el índice
                      estadoTurnos={estadoTurnos}
                      piso={piso}
                      consultorio={consultorio}
                      idEfectorRed={idEfectorRed}
                      idCentroMedico={idCentroMedico}
                      relEfectorCMEspe={relEfectorCMEspe}
                      {...props}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: '-webkit-center' }}
                  >
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: 'white' }}
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {/* {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/gestion'
            },
          }}
        />
      )} */}
    </Grid>
  );
};
